class SandboxPromiseModal {
    private listeners: {
        [key in SandboxPrmiseModalEvent]?: SandboxPromiseModalListener;
    } = {};

    constructor() {
        //
    }

    public Post<T, K>(event: SandboxPrmiseModalEvent, data: K): Promise<T> {
        return new Promise((res, rej) => {
            const promise: SandboxPromiseModalData<T, K> = {
                Data: data,
                Resolve: res,
                Reject: rej,
            };
            const listener: SandboxPromiseModalListener | undefined = this.listeners[event];
            if (listener == undefined) {
                console.error(`${event} not found listener.`);
                rej(`${event} not found listener.`);
            } else {
                listener(promise);
            }
        });
    }

    public On(event: SandboxPrmiseModalEvent, listener: SandboxPromiseModalListener): void {
        this.listeners[event] = listener;
    }

    public Remove(event: SandboxPrmiseModalEvent): void {
        delete this.listeners[event];
    }

    public Clear() {
        this.listeners = {};
    }
}

const Poster = new SandboxPromiseModal();

export default Poster as SandboxPromiseModal;
